(function () {
  const storageKey = 'funcinating_region_recommendation_v1';

  function readChoice() {
    try {
      const raw = window.localStorage.getItem(storageKey);
      if (!raw) return null;

      const choice = JSON.parse(raw);
      if (!choice || Number(choice.expiresAt || 0) < Date.now()) {
        window.localStorage.removeItem(storageKey);
        return null;
      }

      return choice;
    } catch {
      return null;
    }
  }

  function rememberChoice(header, action, countryCode) {
    try {
      const dismissDays = Math.max(1, Number(header.getAttribute('data-region-recommendation-dismiss-days') || 30));
      window.localStorage.setItem(
        storageKey,
        JSON.stringify({
          action,
          countryCode,
          expiresAt: Date.now() + dismissDays * 24 * 60 * 60 * 1000,
        })
      );
    } catch {
      // Ignore storage failures so region selection can still work.
    }
  }

  function getCountryOption(header, countryCode) {
    const normalizedCode = (countryCode || '').toUpperCase();
    const select = header.querySelector('[data-funcinating-country-select]');
    if (!select || !normalizedCode) return null;

    const option = Array.from(select.options).find((item) => item.value.toUpperCase() === normalizedCode);
    if (!option) return null;

    return {
      code: option.value,
      label: option.textContent.trim().replace(/\s+/g, ' '),
      select,
    };
  }

  function formatTemplate(template, countryLabel) {
    return (template || '').replace(/%country%/g, countryLabel);
  }

  async function getVisitorCountry(token) {
    const url = `https://api.ipinfo.io/lite/me?token=${encodeURIComponent(token)}`;
    const response = await fetch(url);
    if (!response.ok) return '';

    const payload = await response.json();
    return String(payload?.country_code || '').toUpperCase();
  }

  async function initHeader(header) {
    const token = header.getAttribute('data-ipinfo-lite-token') || '';
    const currentCountry = (header.getAttribute('data-current-country') || '').toUpperCase();

    if (!token || !currentCountry) return;
    if (window.Shopify?.designMode) return;
    if (readChoice()) return;
    if (window.FuncinatingRegionRecommendationStarted) return;

    window.FuncinatingRegionRecommendationStarted = true;

    try {
      const visitorCountry = await getVisitorCountry(token);
      if (!visitorCountry || visitorCountry === currentCountry) return;

      const countryOption = getCountryOption(header, visitorCountry);
      if (!countryOption) return;

      const showDialog = window.FuncinatingRegion?.showRegionCartClearDialog;
      if (typeof showDialog !== 'function') return;

      const accepted = await showDialog({
        eyebrow: header.getAttribute('data-region-recommend-eyebrow') || '',
        title: formatTemplate(header.getAttribute('data-region-recommend-title-template') || '', countryOption.label),
        message: formatTemplate(header.getAttribute('data-region-recommend-message-template') || '', countryOption.label),
        cancelLabel: header.getAttribute('data-region-recommend-cancel-label') || '',
        acceptLabel: header.getAttribute('data-region-recommend-accept-label') || '',
      });

      if (!accepted) {
        rememberChoice(header, 'dismissed', visitorCountry);
        return;
      }

      countryOption.select.value = countryOption.code;
      countryOption.select.dispatchEvent(new Event('change', { bubbles: true }));
    } catch {
      window.FuncinatingRegionRecommendationStarted = false;
    }
  }

  document.querySelectorAll('[data-funcinating-header]').forEach((header) => {
    initHeader(header);
  });
})();
